import React, { useState } from 'react';
import './Settings.scss';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ROUTE_PATHS } from '../../../routes/paths';
import { fieldSampleAreaEditor, genUser } from 'src/store/common';
import { useStoreContext } from 'src/store/context';

const Settings: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const history = useHistory();
  const [state] = useStoreContext();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onHelpClick =()=>{
    window.open(ROUTE_PATHS.help, '_blank', 'noopener' )
  }
  const onFeedBackClick=()=>{
    window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=4F2CSwVwPUuaFHhBHyhmA4pqM7aQ1oBHuyBVp6-LTzZUQThWWU9OUjVPODFMVk9USTVYUkZORk1QSSQlQCN0PWcu", '_blank', 'noopener')
  }
  const onAboutClick=()=>{
    window.open(ROUTE_PATHS.about, '_blank', 'noopener' )
  }
  return (
    <Router>
      <div className="help-container">
        <Tooltip title="Settings and More">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <i className="fa fa-ellipsis-h" style={{ color: 'white' }} />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={onHelpClick} title="help">
            Help
          </MenuItem>
          <MenuItem onClick={onFeedBackClick} title="feedback">
            Feedback
          </MenuItem>
          <MenuItem onClick={onAboutClick} title="About">
            About
          </MenuItem>
          <div>
          {
            state.user?.appRoles ? (
              (
                genUser(state.user)
              )
              &&
              (
                <div>
                  <Divider />
                  <MenuItem onClick={()=> {history.push(ROUTE_PATHS.contacts)}} title='Contacts' >
                    Contacts
                  </MenuItem>
                </div>
              )
            ):(null)
          }
          {
            state.user?.appRoles ? 
            (
              (
                fieldSampleAreaEditor(state.user)
              )
              &&
              (
                <MenuItem onClick={()=> history.push(`${ROUTE_PATHS.data_process}${ROUTE_PATHS.data_import}`)} title="Data Process">
                  Data Process
                </MenuItem>
              )
            ): (null) 
          }
          <MenuItem onClick={()=> history.push(ROUTE_PATHS.apiKey)} title="API Key">
            API Key
          </MenuItem>
          </div>
        </Menu>
      </div>

    </Router>
  );
}

export default Settings;
